import React from 'react';
export function BenefitsSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-2263">
      <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-2264">
        {/* Left Column */}
        <div className="space-y-10" data-id="element-2265">
          <ul className="list-disc list-inside space-y-4 text-gray-700 text-lg leading-relaxed" data-id="element-2266">
            <li data-id="element-2267">Ability to machine complex shapes in a single set-up!</li>
            <li data-id="element-2268">
              Greater machining productivity compared to multiple setup jobs in
              3x.
            </li>
            <li data-id="element-2269">
              Less human error of incorrect alignment and therefore less scrap
              parts.
            </li>
            <li data-id="element-2270">
              Use of short tools, avoiding of vibration higher quality on
              surface finish no therefore no hand finish.
            </li>
            <li data-id="element-2271">
              Increasing of tool life and reducing of breakages: save of tooling
              and fixture costs.
            </li>
          </ul>

          <div data-id="element-2272">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/preview/uploaded/images/Mikron/Milling%202019/xBenefit,P20of,P205,P20axis,P20machining,P202.jpg.pagespeed.ic.mblYgna1QM.webp" alt="Benefit of 5 axis machining 2" className="block w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-2273" />
          </div>

          <div className="space-y-4" data-id="element-2274">
            <h2 className="text-2xl font-bold text-navy" data-id="element-2275">
              5x Simultaneous High Speed Machining - Things to Consider
            </h2>
            <ul className="list-disc list-inside space-y-3 text-gray-700 text-lg leading-relaxed" data-id="element-2276">
              <li data-id="element-2277">
                Conventional, gear-driven, mechanical rotary/tilt axes do not
                match the feedrates and acceleration of linear drive axes.
              </li>
              <li data-id="element-2278">Conventional rotary axes limit feedrates.</li>
              <li data-id="element-2279">
                Therefore, if a machining center features linear drives on
                linear axes, but features conventional rotary axes, then the
                benefits of HSM are lost
              </li>
            </ul>
          </div>

          <div data-id="element-2280">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/Milling%202019/Benefits%20of%205%20axis%20MILL%20S%20400U.jpg" alt="Benefits of 5 axis MILL S 400U" className="block w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-2281" />
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-10" data-id="element-2282">
          <div data-id="element-2283">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/Milling%202019/Benefit%20of%205%20axis%20machining.jpg" alt="Benefit of 5 axis machining" className="block w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-2284" />
          </div>

          <ul className="list-disc list-inside space-y-4 text-gray-700 text-lg leading-relaxed" data-id="element-2285">
            <li data-id="element-2286">
              Huge saving time in the drilling of holes, due to one set-up which
              allowing drilling to be completed much more quickly.
            </li>
            <li data-id="element-2287">
              Great and new 5-Axis cycle support from all major CAM systems.
            </li>
            <li data-id="element-2288">
              All in all everything with a much faster machining lead time.
            </li>
          </ul>

          <div className="aspect-video rounded-xl overflow-hidden shadow-lg border border-gray-200" data-id="element-2289">
            <iframe className="w-full h-full" src="https://www.youtube.com/embed/H7j0jVxfWSw?wmode=opaque" title="Mikron MILL E 500 U Video" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-2290"></iframe>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg border border-gray-100 text-center space-y-6" data-id="element-2291">
            <p className="text-gray-700 text-lg leading-relaxed" data-id="element-2292">
              The Mikron MILL E 500 U is a 5-Axis efficiency machine in a stiff
              and stabile C-frame construction made out of cast iron. With its
              large-sized guideways and the double-supported rotary table, this
              machine delivers quality on parts and an optimum chip removal rate
              for best efficiency.
            </p>
            <a href="59m7/mikron-high-speed-3-5-axis-milling/efficiency.html" target="_blank" rel="noopener noreferrer" className="inline-block bg-orange hover:bg-orange/90 text-white font-bold py-3 px-8 rounded-lg transition-colors shadow-sm" data-id="element-2293">
              Mikron MILL E 5 Axis
            </a>
          </div>
        </div>
      </div>
    </div>;
}